import { PaymentReturn } from "@/modules/billing/PaymentReturn.tsx";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/payment_return")({
    component: PaymentReturn,
});
